import {
    Button,
    Dialog, DialogActions, DialogBody,
    DialogSurface,
    DialogTitle,
    DialogTrigger, Label,
} from "@fluentui/react-components";
import React, {MouseEventHandler, useEffect} from "react";
import {Column, Row} from "./Layout";
import {AddFilled} from "@fluentui/react-icons";

export type CommonDialogProps<VO> =  {
    dialogContent: VO
    description: Record<keyof VO, string>
    dialogTitle?: string
    onAction?: MouseEventHandler<HTMLButtonElement>
    onActionTitle?: string
    children?: React.ReactNode
}

export default function CommonDialog<VO> (props: CommonDialogProps<VO>) {

    useEffect(()=>{
        console.log(props.dialogContent)

        Object.keys(props.description).map(key => {
            console.log(props.description[key as keyof VO]);
            console.log(props.dialogContent[key as keyof VO]);
        })

    },[])

    return <>
        <Dialog
            modalType={'alert'}
            {...props}>
            <DialogTrigger disableButtonEnhancement>
                <Button
                    appearance={'primary'}
                    icon={<AddFilled />}>
                    {props.dialogTitle || ''}
                </Button>
            </DialogTrigger>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{props.dialogTitle}</DialogTitle>
                        <Column gap={'8px'}>
                            <Row>
                                {props.children && (props.children)}
                            </Row>
                            {Object.keys(props.description).map(key => (
                                <Row gap={'8px'}>
                                <Label style={{fontWeight:'bold'}}>{props.description[key as keyof VO] + ' : '}</Label>
                                {String(props.dialogContent[key as keyof VO])}
                                </Row>
                            ))}
                        </Column>
                        {
                            props.onAction && (
                                <Button
                                    appearance={'primary'}
                                    onClick={props.onAction}>
                                    {props.onActionTitle}
                                </Button>
                            )
                        }
                        <DialogActions>
                            <DialogTrigger disableButtonEnhancement>
                                <Button appearance="secondary">닫기</Button>
                            </DialogTrigger>
                        </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    </>
}